import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false

// Configuration vue gtag
Vue.use(VueGtag, {
  config: {
    id: 'UA-155394870-2'
  }
})

new Vue({
  router,
  store,
  vuetify,
  beforeCreate: function () {
    let urlparams = new URLSearchParams(location.search)
    if (urlparams.has('b')) {
      this.$store.commit('setCustomerStyle', this.$route.query.b)
    }
    if (Array.from(urlparams).length >= 4 &&
      urlparams.has('b') &&
      urlparams.has('v') && (
      urlparams.has('erp') ||
      urlparams.has('ref'))
    ) {
      let linkquerydata = {
        bdkkenn: this.$route.query.b,
        companyPartID: 1,
        verladerID: this.$route.query.v,
        erpAuftNr: '',
        refAuftNr: ''
      }
      if (this.$route.query.erp != null) { linkquerydata.refAuftNr = this.$route.query.erp }
      if (this.$route.query.ref != null) { linkquerydata.refAuftNr = this.$route.query.ref }

      if ((linkquerydata.erpAuftNr !== '' || linkquerydata.refAuftNr !== '') &&
            (linkquerydata.bdkkenn != null && linkquerydata.bdkkenn !== '') &&
            (linkquerydata.companyPartID != null && linkquerydata.companyPartID !== '') &&
            (linkquerydata.verladerID != null && linkquerydata.verladerID !== '')) {
        this.$store.commit('setOrderData', linkquerydata)
        this.$store.dispatch('getTrackAndTraceData')
      } else {
        for (var key in linkquerydata) {
          if (linkquerydata[key] === null || linkquerydata[key] === '') {
            this.$gtag.event('missing request Info', {
              'event_category': 'URL Param Error',
              'event_label': key,
              'value': 1
            })
          }
        }
      }
    } else {
      this.$gtag.event('missing URL Param', {
        'event_category': 'URL Param Error',
        'event_label': Array.from(urlparams).toString(),
        'value': Array.from(urlparams).length
      })
    }
  },
  mounted () {
    if (!Object.keys(this.$store.state.ttlinkquerydata).length > 0) {
      router.push('nodata')
    }
  },
  render: h => h(App)
}).$mount('#app')
